import React, { useEffect } from "react";
import {
  Button,
  FlexDirectionRow,
  FormContainer,
  FormInputContainer,
  MainContainer,
  MainContent,
  SubTitle,
  Title,
} from "../../../../../components/StyledComponents";
import "./styles.module.scss";
import { VersaoAppService } from "../../../services/versaoAppService";
import { BaSeDialogContext, BaSeIcon } from "@base/react";
import { useHistory, useParams } from "react-router-dom";
import { MdContentCopy } from "react-icons/md";
import Select from "../../../../../components/Select";
import {
  maxLength,
  minLength,
  valueIsRequired,
} from "../../../../../utils/regex";
import Input from "../../../../../components/InputControlled";
import { useForm } from "react-hook-form";
import { handleModalStatus } from "../../../../../utils/handleModalStatus";
import { UserActionsContent } from "../../../../../components/UserActionsContent";

export const EditarVersaoApp = () => {
  const { showModal } = React.useContext(BaSeDialogContext);
  const { id } = useParams();

  const { control, handleSubmit, reset, getValues } = useForm({
    defaultValues: {},
  });

  const history = useHistory();

  const handleGoHome = () => {
    history.push("/tabelas-de-controle/VersaoApp");
  };

  const findVersion = async () => {
    const result = await VersaoAppService.find(id);
    if (result) {
      reset(result);
    }
  };

  useEffect(() => {
    findVersion();
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendRequest = async (dataForm) => {
    try {
      const body = { id, ...dataForm };
      await VersaoAppService.update(body);
      handleModalStatus({
        type: "success",
        msgOnSuccess: `A versão APP foi editada com sucesso`,
        onCloseModal: handleGoHome,
        showModal,
      });
    } catch (e) {
      handleModalStatus({
        type: "error",
        msgOnError:
          "Não foi possível editar a versão, Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.",
        showModal,
      });
    }
  };

  return (
    <>
      <MainContainer backgroundColor={"#0061C6"}>
        <FlexDirectionRow>
          <FlexDirectionRow style={{ width: "100%" }}>
            <MdContentCopy size={40} color="#ffffff" />
            <Title>Tabelas de Controle</Title>
          </FlexDirectionRow>
          <BaSeIcon
            onClick={handleGoHome}
            name={"arrow-circle-left"}
            description="voltar"
            color="#ffffff"
            size={50}
          />
        </FlexDirectionRow>
      </MainContainer>
      <MainContent>
        <SubTitle>
          <h3>Editar</h3>
        </SubTitle>

        <FormContainer
          style={{ displayFlex: true, flexDirection: "column" }}
          onSubmit={handleSubmit(sendRequest)}
        >
          <FormInputContainer>
            <Select
              name="plataforma"
              placeholder="Loja"
              options={["ANDROID", "IOS"]}
              control={control}
              rules={{ ...valueIsRequired() }}
            />
          </FormInputContainer>

          <FormInputContainer>
            <Input
              maxLength={20}
              minLength={3}
              name="versao"
              control={control}
              rules={{
                ...valueIsRequired(),
                ...maxLength(20),
                ...minLength(3),
              }}
              placeholder={"Versão"}
            />
          </FormInputContainer>

          <FlexDirectionRow position={"end"} style={{ marginRight: "40px" }}>
            <Button type="submit">Editar versão APP</Button>
          </FlexDirectionRow>
        </FormContainer>
      </MainContent>
      <UserActionsContent data={getValues()}/>
    </>
  );
};
